import { combineReducers, LiftedLoopReducer } from 'redux-loop';

import { calculation, CalculationState } from './calculation';

import {
  calculation as calculationCCTArbCR,
  CalculationState as CalculationStateHACCtArbCR
} from './calculationCCTArbCR';
import {
  calculation as batchCalculationCCTArbCR,
  CalculationState as BatchCalculationStateCCtArbCR
} from './calculationBatchCCTArbCR';
import {
  calculation as calculationTTT,
  CalculationState as CalculationStateTTT
} from './calculationTTT';
import {
  calculation as calculationArbitraryCooling,
  CalculationState as CalculationStateArbitraryCooling
} from './calculationArbitraryCooling';

export interface RootState {
  calculation: CalculationState;
  calculationCCTArbCR: CalculationStateHACCtArbCR;
  batchCalculationCCTArbCR: BatchCalculationStateCCtArbCR;
  calculationTTT: CalculationStateTTT;
  calculationArbitraryCooling: CalculationStateArbitraryCooling;
}

/*
Redux protip: the reducer will grow as your app will become bigger. 
You can split a big reducer into separate functions and combine them with combineReducers.
*/
export const rootReducer: LiftedLoopReducer<any, any> = combineReducers<
  RootState
>({
  calculation,
  calculationCCTArbCR,
  batchCalculationCCTArbCR,
  calculationTTT,
  calculationArbitraryCooling,
}); // calculation is the reduce
